interface ValuesMap<T> {
    positive: T;
    negative: T;
    zero?: T;
}

export const numberFormatter = (locale?: string) => (number: number): string =>
    number ? number.toLocaleString(locale) : '';

export function getMappedValue<T = any>(value: number, map: ValuesMap<T>): T {
    if (!value) {
        return map.zero;
    }

    return value > 0 ? map.positive : map.negative;
}
